export default __webpack_public_path__ + "static/media/049-family.6dad947c.svg";